module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-filtering/column-filtering.component.css
// module id = ./src/app/examples/column-filtering/column-filtering.component.css
// module chunks = main